import React, { useState } from "react";
import { Input, Select, Button, message } from "antd";

const { Option } = Select;

const propertyTypes = [
  { label: "msg.", value: "msg" },
//  { label: "flow.", value: "flow" },
//  { label: "global.", value: "global" },
//  { label: "表达式", value: "expression" },
//  { label: "环境变量", value: "env" },
];

const valueTypes = [
//  { label: "msg.", value: "msg" },
//  { label: "flow.", value: "flow" },
//  { label: "global.", value: "global" },
  { label: "文本", value: "string" },
  { label: "数字", value: "number" },
  { label: "布尔", value: "bool"},
//  { label: "表达式", value: "expression" },
//  { label: "环境变量", value: "env" },
//  { label: "前值", value: "previous" },
];

const valueConds = [  
  { label: "==", value: "==" },
  { label: "!=", value: "!=" },
  { label: "<", value: "<" },
  { label: ">", value: ">" },];

function ConditionList({ value, onChange }) {
  const {property,propertyType,conditions} = value??{property:"payload",propertyType:"msg",conditions:[{ id: 1, cond: "==", type: "string", value: "" }]};

  const handleAddCondition = () => {
    const newId = conditions.length ? conditions[conditions.length - 1].id + 1 : 1;
    const conds = [...conditions, { id: newId, cond: "==", type: "string", value: "" }];
    onChange({property,propertyType,conditions:conds});
  };

  const handleRemoveCondition = (id) => {
    const updatedConditions = conditions.filter(condition => condition.id !== id);
    const reindexedConditions = updatedConditions.map((condition, index) => ({
      ...condition,
      id: index + 1
    }));
    onChange({property,propertyType,conditions:reindexedConditions});
  };

  const handleChangeType = (id, type) => {
    const conds = conditions.map(condition => 
      condition.id === id ? { ...condition, type } : condition
    );
    onChange({property,propertyType,conditions:conds});
  };

  const handleChangeCond = (id, cond) => {
    const conds = conditions.map(condition => 
      condition.id === id ? { ...condition, cond } : condition
    );
    onChange({property,propertyType,conditions:conds});
  };

  const handleChangeValue = (id, value) => {
    const currentCondition = conditions.find(condition => condition.id === id);
    
    if (currentCondition.type === "number" && isNaN(value)) {
      message.error("请输入有效的数字");
      return;
    }

    const conds = conditions.map(condition => 
      condition.id === id ? { ...condition, value } : condition
    );
    onChange({property,propertyType,conditions:conds});
  };

  const handleChangePropertyType = (val) => {
    onChange({property,propertyType:val,conditions});
  };

  const handleChangePropertyValue = (val) => {
    onChange({property:val,propertyType,conditions});
  };

  return (
    <div className="p-4">
      <Input
              addonBefore={<Select
                defaultValue={propertyType}
                onChange={(type) => handleChangePropertyType(type)}
                className="mr-2"
                style={{ width: 100 }}
              >
                {propertyTypes.map(type => (
                  <Option key={type.value} value={type.value}>{type.label}</Option>
                ))}
              </Select>}
              style={{ width: 260 }}
              value={property}
              onChange={(e) => handleChangePropertyValue(e.target.value)}
              className="w-100 mr-2"
              placeholder="请输入值"
            />
      {conditions.map(condition => (
        <div key={condition.id} className="flex flex-row items-center mb-2 mt-2">
          <Select className="mr-2"
           defaultValue={condition.cond}
           onChange={(cond) => handleChangeCond(condition.id, cond)}
           >
            {valueConds.map(cond => (
            <Option key={cond.value}  value={cond.value}>{cond.label}</Option>
            ))}
          </Select>
          <div>
          <Input.Group compact>
            <Input
              addonBefore={<Select
                value={condition.type}
                onChange={(type) => handleChangeType(condition.id, type)}
                className="mr-2"
                style={{ width: 100 }}
              >
                {valueTypes.map(type => (
                  <Option key={type.value} value={type.value}>{type.label}</Option>
                ))}
              </Select>}
              style={{ width: 260 }}
              value={condition.value}
              onChange={(e) => handleChangeValue(condition.id, e.target.value)}
              className="w-100 mr-2"
              placeholder="请输入值"
            />
          </Input.Group>
          </div>
          <div className="flex flex-row items-center">
          <span>-</span>
          <span>&gt;{condition.id}</span>
          </div>
       
          <Button type="link" onClick={() => handleRemoveCondition(condition.id)}>
            删除
          </Button>
        </div>
      ))}
      <Button type="primary" onClick={handleAddCondition}>
        添加条件
      </Button>
    </div>
  );
}

export default ConditionList;